import { Link } from 'react-router-dom';

const NotFoundPage = () => (
  <div className="flex min-h-screen flex-col items-center justify-center bg-slate-950 text-center text-slate-200">
    <div className="rounded-3xl border border-slate-800 bg-slate-900/60 px-16 py-14 shadow-2xl shadow-black/60">
      <p className="text-sm uppercase tracking-[0.3em] text-slate-500">404</p>
      <h1 className="mt-6 text-3xl font-semibold text-brand-100">Page not found</h1>
      <p className="mt-4 max-w-sm text-sm text-slate-400">
        The page you are looking for does not exist. Return to the Energy Intelligence workspace.
      </p>
      <div className="mt-8 flex justify-center gap-4 text-sm font-semibold">
        <Link to="/" className="rounded-full border border-slate-700 px-5 py-2 text-slate-200 hover:border-brand-400 hover:text-brand-200">
          Home
        </Link>
        <Link to="/app/reports" className="rounded-full bg-brand-500 px-5 py-2 text-white hover:bg-brand-400">
          Go to reports
        </Link>
      </div>
    </div>
  </div>
);

export default NotFoundPage;
